
























import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import NetworkDevicesStore from '@/store/network/NetworkDevices.store';

import NetworkDevicesList from '@/components/Networking/Device/NetworkDevicesList.vue';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkDevicesList},
})
export default class NetworkDevices extends Mixins<BaseComponent>(BaseComponent) {
  private devicesStore: NetworkDevicesStore = getModule(NetworkDevicesStore, this.$store);

  private refreshing: boolean = false;

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.logger.debug(`Refreshing data...`);
    this.refreshing = true;

    try {
      this.logger.debug(`Fetching network interfaces`);
      await this.devicesStore.fetchDevices(true);
      this.logger.debug(`Network interfaces fetched`, this.devicesStore.Devices);

    } catch (error) {
      Notify.Error(this.logger, `Could no get network interfaces`, error);
    } finally {
      this.refreshing = false;
    }
  }
}
